const PublicExhibition = () => import(/* webpackChunkName: "PageResources" */ '@/components/Pages/Resources')
const StsFinalistBooth = () => import(/* webpackChunkName: "StsFinalistBooth" */ '@/components/Pages/StsFinalistBooth')
const StsFinalistResources = () => import(/* webpackChunkName: "StsFinalistResources" */ '@/components/Pages/StsFinalistResources')
const WixUrl = () => import(/* webpackChunkName: "WixUrl" */ '@/components/Pages/IframeUrl')

module.exports = [
  {
    path: '/public-exhibition',
    name: 'publicExhibition',
    component: PublicExhibition
  },
  {
    path: '/coming-soon',
    name: 'comingSoon',
    component: WixUrl
  },
  {
    path: '/:partner?/sts-resources',
    name: 'stsFinalistResources',
    component: StsFinalistResources
  },
  {
    path: '/:partner?/finalist-booth/:id',
    name: 'iseffinalistbooth',
    component: StsFinalistBooth
  }
]
